import { z } from "zod";

export const DischargeLetterAccidentSurgeryFormSchema = z.object({
  discharge_recommendations: z.string().optional(),
  epicrisis: z.string().optional(),
  imaging: z.string().optional(),
  lab_results: z.string().optional(),
  main_diagnosis: z.string().optional(),
  medication_upon_discharge: z.string().optional(),
  secondary_diagnosis: z.string().optional(),
  therapy: z.string().optional(),
});
